import React, { useMemo } from "react";

import PropTypes from "prop-types";

import Image from "./Image";
import Pill from "./Pill";
import Simple from "./Simple";
import RadioBtn from "./RadioBtn";

const MODES = {
  simple: Simple,
  image: Image,
  radioBtn: RadioBtn,
  pill: Pill,
};

const Radio = ({ variant = "simple", width, ...props }) => {
  const View = useMemo(() => MODES[variant], [variant]);
  return <View style={{ width }} {...props} />;
};

Radio.propTypes = {
  type: PropTypes.oneOf(Object.keys(MODES)),
};

export default React.memo(Radio);
